import type { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

export enum ListVariant {
  Bullet = 'bullet',
}

const StyledList = styled.ul<{ variant?: ListVariant }>`
  margin-bottom: 1.75rem;
  ${({ variant }) =>
    variant === ListVariant.Bullet &&
    css`
      list-style-type: square;
      margin-left: 1.5rem;
    `}
`

const List: FunctionComponent<{ children: ReactNode; variant?: ListVariant.Bullet }> = ({
  children,
  variant,
  ...otherProps
}) => (
  <StyledList variant={variant} {...otherProps}>
    {children}
  </StyledList>
)

export default List
